import React, { Fragment, memo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/UI/Antd/Button/Button';

import ResultDialog from 'components/UI/ResultDialog/ResultDialog';

import { SuccessDialogActions } from './Reservation.style.js';

const ReservationResults = ({
  successOpened,
  instant_booking,
  handleOk,
  infoDialogShown,
  handleCancel,
  marinaName
}) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <ResultDialog
        className='success-reservation-result'
        visible={successOpened}
        closable={false}
        title={
          instant_booking
            ? t('SUCCESS_RESERVATION_POPUP_INSTANT_BOOKING_SUBJECT')
            : `${t('YOU_REQUEST_HAS_BEEN_SUCCESSFULLY_SENT_TO')} ${marinaName}`
        }
        subtitle={
          instant_booking
            ? t('SUCCESS_RESERVATION_POPUP_INSTANT_BOOKING_BODY')
            : t('RESERVATION_WAITING_FOR_MARINA_APPROVAL')
        }
        data-test-id='test-confirm'
        actions={
          <SuccessDialogActions>
            <Button
              htmlType='button'
              type='primary'
              onClick={handleOk}
              data-test-id='test-confirm'
            >
              {instant_booking
                ? t('SUCCESS_RESERVATION_POPUP_INSTANT_BOOKING_CTA')
                : t('OK')}
            </Button>
          </SuccessDialogActions>
        }
      />

      <ResultDialog
        className='info-home-marina-reservation-result'
        visible={infoDialogShown}
        status='info'
        title={t('RESERVATION_TO_HOVE_MARINA')}
        subtitle={t('CANNOT_SEND_RESERVATION_BECAUSE_YOU_RESIDENT')}
        onCancel={handleCancel}
      />
    </Fragment>
  );
};

export default memo(ReservationResults);
